import { render, staticRenderFns } from "./DeviceRomReleaseBeta.vue?vue&type=template&id=47b89a04&scoped=true"
import script from "./DeviceRomReleaseBeta.vue?vue&type=script&lang=js"
export * from "./DeviceRomReleaseBeta.vue?vue&type=script&lang=js"
import style0 from "./DeviceRomReleaseBeta.vue?vue&type=style&index=0&id=47b89a04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b89a04",
  null
  
)

export default component.exports